"use strict";import{Link as e}from"./src/Link.js";import{defineElement as i}from"@spectrum-web-components/base/src/define-element.js";i("sp-link",e);
//# sourceMappingURL=sp-link.js.map
